module.exports = __webpack_public_path__ + "img/screenshot_certificate_link_desktop.53967116.jpg";